// Port of api/fuel/app/classes/controller/api/monty/views/view/save.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Util from 'offline/util'

function viewToArray(row) {
	var fields = row.view_fields || []
	if (typeof fields === 'string') {
		try { fields = JSON.parse(fields) } catch (e) { fields = [] }
	}
	return {
		id: parseInt(row.view_id, 10) || 0,
		default: parseInt(row.view_default, 10) || 0,
		type: parseInt(row.view_type, 10) || 0,
		context: parseInt(row.view_context, 10) || 0,
		public: parseInt(row.view_public, 10) || 0,
		name: row.view_name,
		fields: fields
	}
}

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var model = params.model || {}
	var viewId = parseInt(model.id, 10) || 0
	var rows = viewId ? DB.query('SELECT * FROM view WHERE user_id = ? AND view_id = ?', [userId, viewId]) : []

	if (!userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	if (!rows.length) {
		return Promise.reject({ error: Constants.API_ERROR_INVALID, offline: true })
	}

	DB.run('UPDATE view SET view_fields = ?, view_type = ?, view_context = ?, view_public = ?, view_name = ?, view_slug = ? WHERE view_id = ?', [
		JSON.stringify(model.fields || []),
		parseInt(model.type, 10) || 0,
		parseInt(model.context, 10) || 0,
		parseInt(model.public, 10) || 0,
		model.name || '',
		Util.slug(model.name || ''),
		viewId
	])

	rows = DB.query('SELECT * FROM view WHERE view_id = ?', [viewId])

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: viewToArray(rows[0])
		}
	})
}
